module.exports = __webpack_public_path__ + "media/cymbal.28ea815e.mp3";